module.exports = __webpack_public_path__ + "img/xmasParty12.faf1b41d.jpg";